import { questionnaireTemplateApi } from '@/lib/api/questionnaireApi';
import { router } from '@inertiajs/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { toast } from 'sonner';

export default function useEditModal({
  templateId,
}: {
  templateId: number | null;
}) {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const queryClient = useQueryClient();
  const updateTemplateMutation = useMutation({
    mutationFn: ({
      id,
      updates,
    }: {
      id: number;
      updates: { title: string; description: string };
    }) => questionnaireTemplateApi.updateById(id, updates),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['template', templateId] });
      router.reload({ only: ['templates'] });
      toast.success('Template updated successfully!');
    },
    onError: (error: any) => {
      if (error.response?.status === 422) {
        toast.error('Please check your input');
      } else {
        toast.error('Failed to update template');
      }
    },
  });

  return {
    isEditModalOpen,
    setIsEditModalOpen,
    updateTemplateMutation,
  };
}
